<script>
  import { _ } from "svelte-i18n";

  export let maincolor = "#2563eb";
  export let darkercolor = "#1e40af";

  export let id;
  export let question = "";
  export let stars = -1;
  export let starsAreValid = true;
  export let onStarsChange = () => {};

  function handleChange() {
    onStarsChange(id, stars);
  }

  $: if (stars != -1 && stars >= 1 && stars <= 5) {
    starsAreValid = true;
  }
</script>

<div class="py-4">
  <p class="mt-20px text-20px ">{question}</p>

  {#if starsAreValid == false}
    <p class="text-red-600 mt-15px italic text-16px">
      {$_("CHOOSE_STARS")}
    </p>
  {/if}
  <div class="mt-20px rating w-min">
    <input
      type="radio"
      bind:group={stars}
      on:change={handleChange}
      name={`appRating${id}`}
      value="5"
      id={`appStar_5${id}`} />
    <label for={`appStar_5${id}`}>☆</label>
    <input
      type="radio"
      bind:group={stars}
      on:change={handleChange}
      name={`appRating${id}`}
      value="4"
      id={`appStar_4${id}`} />
    <label for={`appStar_4${id}`}>☆</label>
    <input
      type="radio"
      bind:group={stars}
      on:change={handleChange}
      name={`appRating${id}`}
      value="3"
      id={`appStar_3${id}`} />
    <label for={`appStar_3${id}`}>☆</label>
    <input
      type="radio"
      bind:group={stars}
      on:change={handleChange}
      name={`appRating${id}`}
      value="2"
      id={`appStar_2${id}`} />
    <label for={`appStar_2${id}`}>☆</label>
    <input
      type="radio"
      bind:group={stars}
      on:change={handleChange}
      name={`appRating${id}`}
      value="1"
      id={`appStar_1${id}`} />
    <label for={`appStar_1${id}`}>☆</label>
  </div>
  <div class="flex flex-row justify-between w-330px mt-4px italic">
    <div class="text-16px">{$_("VERY_BAD(S)")}</div>
    <div class="text-16px">{$_("VERY_GOOD(S)")}</div>
  </div>
</div>

<style windi:preflights:global windi:safelist:global>
  .rating {
    @apply flex flex-row-reverse justify-end;
  }

  .rating > input {
    @apply hidden;
  }

  .rating > label {
    @apply relative w-1.1em cursor-pointer text-gray-600 text-60px;
  }

  .rating > label::before {
    content: "\2605";

    @apply absolute opacity-0 text-$maincolor;
  }

  .rating > label:hover:before,
  .rating > label:hover ~ label:before {
    @apply !opacity-100 text-$maincolor;
  }

  .rating > input:checked ~ label:before {
    @apply opacity-100 text-$maincolor;
  }

  .rating:hover > input:checked ~ label:before {
    @apply opacity-40 text-gray-600;
  }
</style>
